/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id, userId: ZodTypes.Id });

export const DeleteOrganizationUser = {
  id: 'organization-user.patch',
  tag: 'Organization',
  summary: 'Remove organization user',
  description:
    'Only owners may remove other users from the organization.\n' +
    'A non-owner may leave the organization by calling this route with their own ID.\n' +
    '\n' +
    "There must always be at least one owner left after the transaction, else the role can't be changed.",
  method: 'delete',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/user/${params.userId}`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
